import { defineComponent as _defineComponent } from 'vue'
import { exportDebtorsList } from "@/api/revenue";
import DownloadButton from "@/components-UI/buttons/DownloadButton.vue";
import TableColumns from "@/components-UI/table/columns/TableColumns.vue";
import MonthPickerRange from "@/components/base/pickers/MonthPickerRange.vue";
import DebtorsFilters from "@/components/revenue/debtors/DebtorsFilters.vue";
import ListLayout from "@/components_v3/layout/ListLayout.vue";
import DebtorsTable from "@/components_v3/revenue/debtors/DebtorsTable.vue";
import { useDebtors } from "@/services/TablePage/debtors";
import store from "@/store";
import { downloadExcelFile, showServerError } from "@/utils";
import { IColumnsGroup } from "@/utils/ColumnsCreator";
import { computed, onBeforeMount, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router/composables";


export default /*#__PURE__*/_defineComponent({
  __name: 'DebtorsList',
  setup(__props) {

const { getColumns, defaultColumns } = useDebtors();
const columns = ref<IColumnsGroup[]>([]);
const route = useRoute();
const router = useRouter();

const isExportLoading = ref(false);
const exportDebtors = async () => {
    try {
        isExportLoading.value = true;
        const params = { ...store.getters["GET_FILTERS_PARAMS_OBJECT"] };
        const { period_from, period_to } = params;
        const file = await exportDebtorsList(params);
        const name = `Debtors_${period_from}_${period_to}`;
        downloadExcelFile(file, name, 'xlsx', true);
    } catch (err) {
        showServerError(err, 'Не удалось скачать выгрузку');
    } finally {
        isExportLoading.value = false;
    }
};

// --MonthPicker
const filtersEl = ref(null);

const getPeriodFilter = computed(() => {
    return filtersEl?.value?.filters?.filters!.find(f => f.id === 'period');
});

const changeFilters = (period: string[]) => {
    const filter = getPeriodFilter.value;
    if (!filter) return;
    filter.select = period;
    filtersEl.value.filters.submitFilter();
};

const clearDateRangeFilter = () => {
    const filter = getPeriodFilter.value;
    filter.select = [];
    filtersEl.value.filters.submitFilter();
};

watch(() => route.query, (query: any) => {
    store.commit('revenueModule/SET_FILTERS', query);
}, { deep: true });

onBeforeMount(() => {
    columns.value = getColumns();

    if (route.params.setSavedFilters === 'true') {
        router.replace({
            params: { setSavedFilters: 'false' },
            query: store.getters['revenueModule/GET_SAVED_FILTERS'],
        });
    }
});

return { __sfc: true,getColumns, defaultColumns, columns, route, router, isExportLoading, exportDebtors, filtersEl, getPeriodFilter, changeFilters, clearDateRangeFilter, DownloadButton, TableColumns, MonthPickerRange, DebtorsFilters, ListLayout, DebtorsTable }
}

})